import { Outlet, useOutletContext } from 'react-router-dom';
import { useEffect } from 'react';
import { SendMessage } from 'react-use-websocket';
import { PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import {
  useLazyGetTransactionsDictionariesQuery,
  useLazyGetTransactionsDictionariesWithoutGLQuery,
  useLazyGetTransactionsBaseCurrencyQuery,
  useLazyGetTransactionsCurrenciesQuery,
  useLazyGetTransactionsCountriesQuery,
} from '../../store/dictionaries/services';

import cn from './styles.module.css';

const Export = () => {
  const [getDictionaries] = useLazyGetTransactionsDictionariesQuery();
  const [getDictionariesWithoutGL] =
    useLazyGetTransactionsDictionariesWithoutGLQuery();
  const [getTransactionBaseCurrency] =
    useLazyGetTransactionsBaseCurrencyQuery();
  const [getTransactionCurrencies] = useLazyGetTransactionsCurrenciesQuery();
  const [getTransactionCountries] = useLazyGetTransactionsCountriesQuery();

  const {
    activePermissions,
    pspPartnerAccounts,
    countries,
    currencies,
    baseCurrency,
    accounts,
  } = useAppSelector((state) => state.transactionsDictionaries);

  const { sendMessage } = useOutletContext<{ sendMessage: SendMessage }>();

  useEffect(() => {
    if (
      activePermissions &&
      activePermissions?.includes(PermissionEnum.TRANSACTIONS_EXPORT_LIST)
    ) {
      if (!pspPartnerAccounts) {
        getDictionariesWithoutGL();
      }

      if (!accounts) {
        getDictionaries();
      }

      if (!currencies) {
        getTransactionCurrencies();
      }

      if (!countries) {
        getTransactionCountries();
      }

      if (!baseCurrency) {
        getTransactionBaseCurrency();
      }
    }
  }, [
    activePermissions,
    baseCurrency,
    currencies,
    countries,
    pspPartnerAccounts,
    accounts,
  ]);

  useEffect(() => {
    let title = 'Export transactions';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.exportLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions) {
    if (activePermissions.includes(PermissionEnum.TRANSACTIONS_EXPORT_LIST)) {
      content = (
        <div className={cn.export}>
          <div className={cn.exportTitle}>Export transactions</div>
          <div className={cn.columns}>
            <Outlet context={{ sendMessage }} />
          </div>
        </div>
      );
    } else {
      content = <PermissionDenied />;
    }
  }

  return content;
};

export default Export;
